import type { ObservationDefinition } from "@medplum/fhirtypes";
import { FINDING_ENTITY_ID_SYSTEM } from "@repo/fhir-systems/identifiers";
import { getDataStoreClient } from "../core/provider";
import { readFindingDefinitionRow } from "../fhir/finding-definition-storage";
import type { ObservationRow } from "../fhir/types";

export const observations = () => getDataStoreClient().getCollection("observation");

export function findingRow(id: string): ObservationRow {
  const found = observations().get(id);
  if (!found) throw new Error(`Finding '${id}' is not loaded`);
  return found;
}

export function findingDefinitionRow(definition: { url: string; version: string }): ObservationDefinition {
  const ref = `${definition.url}|${definition.version}`;
  const found = [...getDataStoreClient().getCollection("findingDefinition").values()].find(
    (candidate) => candidate.findingDefinitionRef === ref,
  );
  if (!found) throw new Error(`Finding definition '${ref}' is not loaded`);
  return found;
}

/** The newest loaded revision: what the exam card offers for a finding not yet recorded. */
export function currentFindingDefinitionVersion(url: string): number {
  const versions = [...getDataStoreClient().getCollection("findingDefinition").values()]
    .map((row) => readFindingDefinitionRow(row).spine)
    .filter((spine) => spine.url === url)
    .map((spine) => spine.version);
  if (!versions.length) throw new Error(`Finding definition '${url}' is not loaded`);
  return Math.max(...versions);
}

export function addExamMember(examId: string, findingId: string): void {
  observations().update(examId, (draft) => {
    draft.hasMember = [
      ...(draft.hasMember ?? []),
      { identifier: { system: FINDING_ENTITY_ID_SYSTEM, value: findingId } },
    ];
  });
}
